<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <v-card v-if="$store.getters.getLanguageList">     
            <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
            <div v-if="getCheckAnswerEvent">{{checkAnswer()}}</div>

            <v-toolbar dense @click="collapse = !collapse" color="blue lighten-5">                
                <v-icon v-if="collapse">expand_more</v-icon>
                <v-icon v-if="!collapse">chevron_right</v-icon>
                <v-toolbar-title>{{mycontent.title}} (assignment)</v-toolbar-title>
            </v-toolbar>
            <v-card>
               <v-card-text>
                   <div v-if="collapse" v-html="mycontent.assignment"></div>
                </v-card-text>
            </v-card>
            <v-toolbar dense @click="collapse2 = !collapse2" color="blue lighten-5">                
                <v-icon v-if="collapse2">expand_more</v-icon>
                <v-icon v-if="!collapse2">chevron_right</v-icon>
                <v-toolbar-title>Result</v-toolbar-title>
            </v-toolbar>
            <v-card>
               <v-card-text>
                   <div v-if="collapse2" v-html="mycontent.requestedFile"></div>
                </v-card-text>
            </v-card>

            <v-card>
                <v-toolbar dense color="blue lighten-5">
                        <v-icon @click="saveCode()" style="margin:5px;" class="material-icons-outlined">cloud_upload</v-icon>
                        <v-icon @click="readOriginalProgram()" style="margin:5px;" class="material-icons-outlined">refresh</v-icon>
                        <v-spacer></v-spacer>
                        <v-btn outlined style="margin-right:50px;">{{grade}}%</v-btn>
                        <v-icon @click="showExecuteInfo = !showExecuteInfo" :color="getResultColor()" large style="magrin-right:10px;">reorder</v-icon>
                        <v-icon @click="checkAnswer()" color="green" large style="magrin-right:5px;">check_circle_outline</v-icon>
                </v-toolbar>  
                <v-card v-if="showExecuteInfo" color="lime lighten-5">
                    <v-card-text>
                        <p v-for="(rule, index) in executionResult" :key="index">
                            <v-icon v-if="rule.res" color="green">check_circle</v-icon>
                            <v-icon v-if="!rule.res"  color="red">error</v-icon>                                
                            {{rule.desc}} </p>
                    </v-card-text>     
                </v-card>   
                <div>
                <codemirror @blur="saveCode()"  class="border-top" ref="myCm1" v-model="mycontent.requestedFile"
                              :options="getCmOptions()"
                     >
                </codemirror>
                    <v-card v-if="showMyAnswer">
                        <v-toolbar dense color="blue lighten-5">                        
                            <v-toolbar-title>Authors solution:</v-toolbar-title>
                            
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </v-card>
                </div>
            </v-card>

        </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
// import { closeSync } from 'fs';
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.js'
// language js
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/css/css.js'
import 'codemirror/mode/xml/xml.js'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/mode/python/python.js'
import 'codemirror/mode/sql/sql.js'
import 'codemirror/mode/php/php.js'
import 'codemirror/mode/clike/clike.js'

// language hint addons
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/javascript-hint.js'
import 'codemirror/addon/hint/css-hint.js'
import 'codemirror/addon/hint/xml-hint.js'
import 'codemirror/addon/hint/html-hint.js'
import 'codemirror/addon/hint/sql-hint.js'
import 'codemirror/addon/hint/anyword-hint.js'

// FULL SCREEN ADDON
import 'codemirror/addon/display/fullscreen.js'
import 'codemirror/addon/display/fullscreen.css'

  // merge css
import 'codemirror/addon/merge/merge.css'
  // merge js
import 'codemirror/addon/merge/merge.js'
import axios from './../../axios-auth'
// import configData from '../../config.js'

import * as check_rules from '../../assets/check_rules.js'

export default {   
    data() {
        return {
                showExecuteInfo: false,
                executionInfo: '',
                executionResult: [],
                grade: 0,
                isRunning: false,
                task_id: 0,
                showMyAnswer: false,
                originalContent : null,
                mycontent:  {
                    title: 'loading...',
                    assignment: 'loading...',

                },
                feedback: null,
                showMyHelp: false,
                needInit : false,
                collapse: true,
                collapse2: true
        }
    },
    components :{
        codemirror
    },

    computed: 
        mapGetters([
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    'getLanguageList'
                    ])
    ,    
    props: { 
        dcontent: Object
    },
    methods: {
        initData() {            
            this.needInit = false         
            this.$store.commit('setFeedback', null) 
            this.mycontent = this.dcontent.data.content
            this.mycontent.authorsFile = '';
            this.originalContent = ""+this.mycontent.requestedFile
            this.grade = this.dcontent.score
            this.task_id = this.dcontent.task_id
            axios.get('/load-program/' + this.task_id, this.$store.getters.getAxiosConfig )
            .then((res) => {
                // set data to var
                const data = res.data.code

                if (data.length > 2) {
                    this.mycontent.requestedFile = data
                }            
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
            },
        checkAnswer() {
            this.$store.commit('setCheckAnswerEvent', false)
            // compare with myResult
            this.checkCode()
            // if (questionResult < 100) 
            this.$store.commit('setTryAgainEvent',false)
        },
        showAnswer() { 
            this.$store.commit('setShowAnswerEvent', false)
        },
        getResultColor() {
            if (this.grade == 0 && this.vplExecutionInfo == '') return 'primary'
            if (this.grade == 0) return 'red'
            if (this.grade == 100) return 'green'
            return 'orange'
        },
        getCompilerColor() {
            if (this.vplCompilerInfo.lenght > 11) return 'red'
            if (this.vplCompilerInfo == '' && this.vplExecutionInfo == '') return 'primary'
            return 'green'
        },
        checkCode() {
          this.executionInfo = ''  
          var _res = false
          this.executionResult = []  
          var correct = 0
          for(let i = 0; i < this.mycontent.rules_list.length; i++) {
//              console.log(this.mycontent.rules_list[i])
              _res = check_rules.check_rule(this.mycontent.rules_list[i].rule_id, 
                                                              this.mycontent.rules_list[i].content, 
                                                              this.mycontent.requestedFile)
              if (_res) correct++             
              this.executionResult.push(
                  { res: _res,
                    desc : this.mycontent.rules_list[i].description
                  })

          }  
          this.grade = correct / this.mycontent.rules_list.length * 100
          this.showExecuteInfo = true
          this.$store.commit('setAnswer',this.describeAnswer('user',this.grade,''))
          this.$store.commit('setCheckRatingEvent',true)
        },
        describeAnswer(user, score, lst) {
            return {
                solver: user,
                type: 6,
                answer: lst,
                answer_index: null, 
                rating: score
            }
        },
        saveCode() {
            const data = {
                task_id : this.task_id,
                files: this.mycontent.requestedFile
            }

            axios.post('/save-program', data, this.$store.getters.getAxiosConfig )
            .then(() => {
                // set data to var
                
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })

        },
        readOriginalProgram() {
            this.mycontent.requestedFile = this.originalContent
        },
        getCmOptions() {
            return  {
                        tabSize: 4,
                        styleActiveLine: true,
                        lineNumbers: true,
                        line: true,
                        mode: this.$store.getters.getEditorType,
                        lineWrapping: false,
                        extraKeys: {'Ctrl-Space': 'autocomplete',
                                'F11'(cm) {
                                    cm.setOption("fullScreen", !cm.getOption("fullScreen"))
                                },
                                'Esc'(cm) {
                                if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false)
                            }
                        }
                }
        }


    },
    mounted() {
        this.needInit = true
    }
}
</script>

<style>

</style>